import axios from 'axios';

const firstValidationMessage = (errors: unknown): string | null => {
  if (!errors || typeof errors !== 'object') return null;

  for (const value of Object.values(errors as Record<string, unknown>)) {
    if (typeof value === 'string' && value.trim()) return value;
    if (!Array.isArray(value)) continue;
    const found = value.find((item) => typeof item === 'string' && item.trim());
    if (typeof found === 'string') return found;
  }

  return null;
};

export const incorporationErrorMessage = (payload: unknown, fallback: string): string => {
  if (!payload || typeof payload !== 'object') return fallback;

  const data = payload as { message?: unknown; errors?: unknown };
  const validation = firstValidationMessage(data.errors);
  if (validation) return validation;
  if (typeof data.message === 'string' && data.message.trim()) return data.message;
  return fallback;
};

export const readIncorporationError = (error: unknown, fallback: string): string => {
  if (!axios.isAxiosError(error)) return fallback;
  return incorporationErrorMessage(error.response?.data, fallback);
};
